import ResourceDocumentTypeModel   from 'Models/intervention/ResourceDocumentTypeModel';
import doc                         from 'decorators/doc';
import { computed }                from 'mobx';
import InterventionPrivateApiModel from '../../abstracts/InterventionPrivateApiModel';

export default class TaskZoneResourceDocumentTypeModel extends InterventionPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'taskZone': id;
	}> = {};

	static get path(): string {
		return '/task_zone_resource_document_types/{?id}';
	}

	@doc.model(ResourceDocumentTypeModel) declare resourceDocumentType: ResourceDocumentTypeModel;

	@computed
	public get resourceDocumentTypeId() {
		return this.get('resourceDocumentType.id', 0);
	}

	@computed
	public get resourceDocumentTypeIri() {
		return this.get('resourceDocumentType.@id');
	}

	@computed
	public get taskZoneId() {
		return this.get('taskZone.id');
	}

	public _sorts: ModelSortsExtended<{
		'id': string;
		'resourceDocumentType.position': string;
		'updatedAt': string;
	}> = {};
}
